<div
  class="rounded-circle border border-1 dynamic-picture"
  [style.background-image]= "backgroundImage"
  triggers="mouseenter:mouseleave"
  container="body"
  placement="right"
  [popover]="image"
>
</div>
<ng-template #image>
    <div
      class="popover-picture"
      [style.background-image]= "backgroundImage"
    >

    </div>
</ng-template>
